import React, { Component } from 'react';

import styles from './index.module.less';

export interface HTMLFragmentProps {
  visible?: boolean; // 显示
  content: string;
  value: any;
  style?: object; // 样式
}

export default class HTMLFragment extends Component<HTMLFragmentProps> {
  render () {
    let { content, visible, style, renderEnv, value, ...args } = this.props;
    const visibleStyle = {
      display: visible === false ? 'none' : ''
    }
    const currentStyle = Object.assign({}, visibleStyle, style)
    if (renderEnv === 'designer' && !content) {
      content = "<div style='width:100%;height:100px;line-height:100px;text-align:center'>" + lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18AEAEE804480008', '这里可以编写html') + "</div>";
    } else {
      content = value || content;
    }
    return (
      <div className={styles['lib-HTMLFragment']} style={currentStyle} {...args}>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  }
}
